exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-page .vue-grid-item[data-v-1b821b6f]{-webkit-transition:none;transition:none}", ""]);

// exports
